/* eslint-disable */
export const SEND_RESET = 'SEND_RESET';
export const SEND_RESET_END = 'SEND_RESET_END';
